
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hipporuber",
      function () {
        return require("private-next-pages/hipporuber.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hipporuber"])
      });
    }
  